import { jsx, jsxs } from 'react/jsx-runtime';

const styles = {
    base: 'w-fit items-center justify-center text-text-link-default text-body-strong tablet:text-body-large-strong cursor-pointer active:text-text-link-active hover:text-text-link-active',
    focus: 'focus:ring-3 focus:ring-border-focus-1 active:ring-0 focus:py-0 focus:outline-none focus:border-transparent rounded-radius-200 ',
    visited: 'visited:text-text-link-visited',
    iconClass: `transition-colors`,
    text: `flex flex-inline items-center active:rounded-md border-b active:border-transparent active:bg-bg-primary group-focus:border-transparent group-hover:border-transparent px-space-50`,
};
const TextLink = ({ as, children, leftIcon, rightIcon, ...props }) => {
    const Component = as || 'a';
    // Text-only link
    if (!leftIcon && !rightIcon) {
        return (jsx(Component, { className: `inline-flex group ${styles.base} ${styles.visited} ${styles.focus}`, ...props, children: jsx("span", { className: styles.text, children: children }) }));
    }
    // Icon variant
    return (jsxs(Component, { className: `inline-flex group ${styles.base} ${styles.visited} ${styles.focus}`, ...props, children: [leftIcon && jsx("span", { className: `mr-space-200 ${styles.iconClass}`, children: leftIcon }), jsx("span", { className: styles.text, children: children }), rightIcon && jsx("span", { className: `ml-space-200 ${styles.iconClass}`, children: rightIcon })] }));
};

export { TextLink };
